
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="List" -->
				<el-form-item>
					<el-input  v-model="filters.Name"   placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input  v-model="filters.Number"   placeholder="设备编号"></el-input>
				</el-form-item>	
				<el-form-item >
                <el-select  v-model="filters.Type" clearable filterable placeholder="状态"  >
                 <el-option label="授权入场" value="0"> </el-option>
                 <el-option label="已出场" value="1"></el-option>   
                 <el-option label="注销授权" value="2"></el-option>                

                   </el-select>	
				</el-form-item>							
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="List" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click="Cancel">注销授权</el-button>
					<!-- <el-button size="width:100%; height:100%;" type="warning" :loading="Loading" v-on:click="exportReport" icon="el-icon-search">导出设备</el-button>					 -->
				</el-form-item>			
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="ListData" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="CardNumber" label="授权设备编号" width="200" sortable>
			</el-table-column>		
			<el-table-column prop="CabinetNumber" label="柜号" width="120" sortable>
			</el-table-column>					
			<el-table-column prop="Name" label="名称" width="180" sortable>
			</el-table-column>
			<el-table-column prop="CustomerType" label="客户类型" width="120" :formatter="CustomerType" sortable>
			</el-table-column>			
			<el-table-column prop="Telephone" label="手机号码" width="150" sortable>
			</el-table-column>
			<el-table-column prop="IdCard" label="身份证号码" width="150"  sortable>
			</el-table-column>
			<el-table-column prop="CreationTime" label="授权时间" width="180"  sortable>
			</el-table-column>	
			<el-table-column prop="OutTime" label="出场时间" width="180"  sortable>
			</el-table-column>	
					
 			<el-table-column prop="ImageUrl" label="头像" width="150" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				     <img v-if="scope.row.ImageUrl!=null"  @click="see(scope.row.ImageUrl)"  :src="scope.row.ImageUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>	
			</el-table-column>           
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
            <el-table-column prop="State" label="状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success"  size="medium" v-if="scope.row.State==0">授权入场</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.State==1">已出场</el-tag>
                   <el-tag type="danger" size="medium" v-if="scope.row.State==2">注销授权</el-tag>                
                  </div>
                  </template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-tag>当前有{{Count}}位教练</el-tag> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

	    <!-- 查看图片 -->
        <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>

        <el-dialog id="tt" title="照片上传" v-model="imageVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
		</el-dialog>

    <el-dialog  title="注销授权"  v-model="AuthorizationVisible" :close-on-click-modal="false" @submit.native.prevent  >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
         <div >      
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >
					<input class="input" ref="siteInput2"  v-model="AuthorizationNumber"  @click.native="CancelAuthorization"  :autofocus="focusvalue" placeholder="设备识别编号"></input>
				</el-form-item>	
				<el-form-item>
                    <el-button type="danger" @click="CancelAuthorization()">注销授权</el-button>					
				</el-form-item>								
			</el-form>	
	    	 </el-col>
        </div>
      </div>
      </el-card>
      </el-col>
      </el-row>	
	</el-dialog>			        
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import { PreparationsList,CancelPreparations } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					Name: '',
					Number:'',
					Type:''
				},
				focusvalue:false,
				AuthorizationNumber:'',
				AuthorizationVisible:false,
				imgUrl:'',
				imageVisible:false,
                seeImageVisible:false,
                radio:'0',
		       Loading:false,
				Count:0,
				options:[],
				ListData:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
			}
		},
		methods: {
			Cancel(){
				this.AuthorizationVisible=true;
			 this.$nextTick(function(){
			  this.$refs['siteInput2'].focus();
			  })				
			},
	    CancelAuthorization(){
			
			  let para= {
				  cardNumber:this.AuthorizationNumber
			  };
			  	CancelPreparations(para).then((res) => {
					  						//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									this.AuthorizationVisible=false;
									this.List();								
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								    });
								}
					}).catch(() => {
				});				
	    },			
			upload(param)
			{
			    var fileObj=param.file;
				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("BasicInformationId",this.memberId)
			  	UploadMemberImage(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.imageList(this.memberId);
						// this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });
			},			
			  see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },
            CustomerType: function (row, column) {
				return row.CustomerType == 1 ? '散客' :  '会员' ;
			},			
// 		exportReport()
// 			{
// 				this.Loading=true;
// 				 let para = {
// 				};  
//   				let downloadName="门票管理";

// 				 TicketExportReport(para).then((res)=>{	
					 
// 					 let {status}=res;	
// 					//  console.log(status);
// 					 if(status==200)
// 					 {
// 	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
// 	   var downloadElement = document.createElement('a');
// var href = window.URL.createObjectURL(blob); //创建下载的链接
// downloadElement.href = href;
// downloadElement.download = downloadName; //下载后文件名
// document.body.appendChild(downloadElement);
// downloadElement.click(); //点击下载
// document.body.removeChild(downloadElement); //下载完成移除元素
// window.URL.revokeObjectURL(href); //释放掉blob对象
// 						 this.Loading=false;
// 					 }
// 					 else
// 					 {
// 						 this.Loading=false;
// 					 }

// 		   })
// 			},			
  
			//获取列表
		
			List() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					Number:this.filters.Number,
					Type:this.filters.Type
				};
				this.listLoading = true;
				//NProgress.start();
				PreparationsList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					console.log(res.data);
					this.total = res.data.TotleCount;
					this.ListData =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							




			selsChange: function (sels) {
				this.sels = sels;
			},


   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
   	handleCurrentChange(val) {
				this.page = val;
				this.List();
			},
		},
		mounted() {
			this.List();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// Authorization.vue?5a9d80e6